import { combineReducers } from "@reduxjs/toolkit";
import inputReducer from "Dashboard/scenes/ConcreteBase/scenes/Input/inputSlice";
import outputReducer from "Dashboard/scenes/ConcreteBase/scenes/Output/outputSlice";

const rootReducer = combineReducers({
  input: inputReducer,
  output: outputReducer,
});

export default rootReducer;
